const iframeWrapper = document.querySelector('.interactive-tool-wrapper');

if (iframeWrapper) {
    const startBtn = document.querySelector('.interactive-tool-btn--start');

    if (window.location.search.indexOf('start') > -1) {
        iframeWrapper.classList.remove('-closed');
    }

    [iframeWrapper, startBtn].forEach((el) => {
        el.addEventListener('click', () => {
            iframeWrapper.classList.toggle('-closed');

            if (
                iframeWrapper.classList.contains('-closed') &&
                window.location.search.indexOf('start') > -1
            ) {
                window.location.href = window.location.href.split('?')[0];
            }
        });
    });
}

window.addEventListener('message', (event) => {
    if (event.origin !== window.location.origin) {
        return;
    }

    if (event.data && event.data.event) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(event.data);
    }
});
